import React from "react";
import "./ProcessSection.css";
import { FaHive, FaLeaf, FaCogs, FaBoxOpen } from "react-icons/fa";
import apa from "../../assets/apa.jpg"; 

const ProcessSection = () => {
  return (
    <section className="process-section">
      <div className="process-header">
        <h2>Do Ninho à Sua Mesa</h2>
        <p>
          A jornada artesanal que transforma o néctar em mel, com dedicação, tradição e respeito à natureza.
        </p>
      </div>
      <div className="timeline">
        <div className="timeline-item" data-aos="fade-up" data-aos-delay="100">
          <div className="timeline-icon">
            <FaHive />
          </div>
          <div className="timeline-content">
            <h3>Seleção das Abelhas</h3>
            <p>
              Selecionamos as abelhas mais dedicadas em um ambiente natural, garantindo harmonia e qualidade.
            </p>
          </div>
        </div>

        <div className="timeline-item" data-aos="fade-up" data-aos-delay="200">
          <div className="timeline-icon">
            <FaLeaf />
          </div>
          <div className="timeline-content">
            <h3>Colheita do Néctar</h3>
            <p>
              Técnicas tradicionais asseguram a extração do néctar mais puro, preservando seu sabor natural.
            </p>
          </div>
        </div>

        <div className="timeline-item" data-aos="fade-up" data-aos-delay="300">
          <div className="timeline-icon">
            <FaCogs />
          </div>
          <div className="timeline-content">
            <h3>Processamento Artesanal</h3>
            <p>
              O néctar se transforma em mel, mantendo todas as propriedades benéficas e seu sabor inconfundível.
            </p>
          </div>
        </div>

        <div className="timeline-item embalagem" data-aos="fade-up" data-aos-delay="400">
          <div className="timeline-icon">
            <FaBoxOpen />
          </div>
          <div className="timeline-content">
            <h3>Embalagem Cuidadosa</h3>
            <p>
              Cada embalagem é preparada com atenção aos detalhes, sendo embaladas, rotuladas e atestadas pela APA para que seu mel chegue com a máxima qualidade.
            </p>
            <img src={apa} alt="APA" className="apa-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
